import React from "react";
import TelegramSosmed from "./TelegramSosmed";

const TelegramMain = () => {
  return (
    <section id="telegram" className="pt-12">
      <div className="">
        <TelegramSosmed />
      </div>
    </section>
  );
};

export default TelegramMain;
